import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewQrCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_16472_23713",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3.668,
				y: 3.666,
				width: 4.267,
				height: 4.267,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.668,
			y: 3.666,
			width: 4.267,
			height: 4.267,
			rx: .8,
			stroke: "#172B4D",
			strokeWidth: 2.4,
			mask: "url(#path-1-inside-1_16472_23713)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-2_16472_23713",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3.668,
				y: 10.066,
				width: 4.267,
				height: 4.267,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.668,
			y: 10.066,
			width: 4.267,
			height: 4.267,
			rx: .8,
			stroke: "#172B4D",
			strokeWidth: 2.4,
			mask: "url(#path-2-inside-2_16472_23713)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-3_16472_23713",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 10.066,
				y: 3.666,
				width: 4.267,
				height: 4.267,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.066,
			y: 3.666,
			width: 4.267,
			height: 4.267,
			rx: .8,
			stroke: "#172B4D",
			strokeWidth: 2.4,
			mask: "url(#path-3-inside-3_16472_23713)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.6,
			cy: 10.6,
			r: .533,
			fill: "#172B4D"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.799,
			cy: 10.6,
			r: .533,
			fill: "#172B4D"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.799,
			cy: 13.801,
			r: .533,
			fill: "#172B4D"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.6,
			cy: 13.801,
			r: .533,
			fill: "#172B4D"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.201,
			cy: 12.199,
			r: .533,
			fill: "#172B4D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 1H3a2 2 0 0 0-2 2v2M13 1h2a2 2 0 0 1 2 2v2M13 17h2a2 2 0 0 0 2-2v-2M5 17H3a2 2 0 0 1-2-2v-2",
			stroke: "#172B4D",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
export default SvgNewQrCode;
